import { Icon, type IconName } from "../Icon/Icon";
import { TAB_ICON } from "../Icon/tabIcons";
import type { SegmentIcon } from "./Segment";

const segmentIcon =
  (name: IconName): SegmentIcon =>
  ({ color, size }) => <Icon name={name} color={color} size={size} />;

// Same glyphs the mobile switcher drew before it moved here: athlete (training),
// coach (the team, shared with the roster tab), admin (product owner), the ⚙︎
// of ME-1 and the bell of INBOX-10.
export const AthleteSegmentIcon = segmentIcon("activity");
export const CoachSegmentIcon = segmentIcon(TAB_ICON.athletes);
export const AdminSegmentIcon = segmentIcon("shield");
export const SettingsSegmentIcon = segmentIcon(TAB_ICON.settings);
export const BellSegmentIcon = segmentIcon("bell");
